'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Clock(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 12 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 12 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-clock ' + className, xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 12 12' },
    _react2.default.createElement(
      'g',
      { fill: color, fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M12 6A6 6 0 0 1 0 6a6 6 0 0 1 12 0zm-1.25 0A4.75 4.75 0 0 0 6 1.25 4.75 4.75 0 0 0 1.25 6 4.75 4.75 0 0 0 6 10.75 4.75 4.75 0 0 0 10.75 6z' }),
      _react2.default.createElement('path', { d: 'M5.443 6.823a.297.297 0 0 1-.12-.242V2.613a.28.28 0 0 1 .084-.206.282.282 0 0 1 .205-.084h.775a.28.28 0 0 1 .205.084.28.28 0 0 1 .085.206v3.436l1.621 1.16a.268.268 0 0 1 .11.195.297.297 0 0 1-.062.217l-.435.629a.309.309 0 0 1-.194.12.262.262 0 0 1-.217-.047l-2.057-1.5z' })
    )
  );
}

Clock.propTypes = _bcPropTypes.iconShape;

exports.default = Clock;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Clock/Clock.js
// module id = 182
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15